import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React, { PureComponent } from 'react';

import Button from '../../../common/Button';

interface IProps {
  toggleImportModal: () => void;
  importCustomers: (file: File) => void;
  importing: boolean;
  importError?: any;
  history: any;
}

interface IState {
  selectedFile?: File;
}

class ImportModal extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {};

    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.handleImport = this.handleImport.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  public componentDidUpdate(prevProps: IProps) {
    const { importing, history } = this.props;

    if (prevProps.importing && !importing && !this.props.importError) {
      history.push('/dashboard/customers/list');
    }
  }

  public handleFileSelect(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (file) {
      this.setState({ selectedFile: file });
    }
  }

  public handleImport() {
    const { importCustomers } = this.props;
    const { selectedFile } = this.state;

    if (selectedFile) {
      importCustomers(selectedFile);
    }
  }

  public handleKeyPress(event: React.KeyboardEvent) {
    if (event.key === 'Enter' && this.state.selectedFile && !this.props.importing) {
      this.handleImport();
    }
  }

  public render() {
    const { toggleImportModal, importing, importError } = this.props;
    const { selectedFile } = this.state;

    return (
      <Dialog open onClose={() => !importing && toggleImportModal()} onKeyPress={this.handleKeyPress}>
        <DialogTitle>
          <FontAwesomeIcon className="header-icon" icon={faUpload} />
          <span style={{ marginLeft: '8px' }}>Importar Clientes</span>
          <IconButton
            edge="end"
            size="small"
            className="dialog-close-button"
            onClick={() => toggleImportModal()}
            disabled={importing}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box minWidth={400}>
            <Typography variant="body2" gutterBottom>
              Selecione um ficheiro Excel (.xlsx) para importar clientes
            </Typography>
            <Box mt={2}>
              <input
                accept=".xlsx"
                style={{ display: 'none' }}
                id="raised-button-file"
                type="file"
                onChange={this.handleFileSelect}
                disabled={importing}
              />
              <label htmlFor="raised-button-file">
                <Button variant="contained" color="default" component="span" disabled={importing}>
                  Escolher Ficheiro
                </Button>
              </label>
              {selectedFile && (
                <Box ml={2} component="span">
                  <Typography variant="body2" component="span">
                    {selectedFile.name}
                  </Typography>
                </Box>
              )}
            </Box>
            {importError && (
              <Box mt={2}>
                <Typography variant="body2" color="error">
                  {importError.response?.data?.message || importError.response?.data?.error || 'Erro ao importar clientes'}
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <Box p={2} pt={0}>
          <DialogActions>
            <Button
              color="default"
              variant="contained"
              onClick={() => toggleImportModal()}
              disabled={importing}
            >
              Cancelar
            </Button>
            <Button
              color="secondary"
              variant="contained"
              startIcon={importing ? <CircularProgress size={20} /> : <FontAwesomeIcon icon={faUpload} />}
              onClick={this.handleImport}
              disabled={!selectedFile || importing}
            >
              {importing ? 'A importar...' : 'Importar'}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    );
  }
}

export default ImportModal;